import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { api } from "../api";
import { AUTH0_AUDIENCE } from "../env";

/**
 * Returns a wrapper around `api()` that automatically injects the Auth0
 * Bearer token into every request.
 */
export function useAuthApi() {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(
    async <T = unknown>(url: string, options: RequestInit = {}): Promise<T | null> => {
      const token = await getAccessTokenSilently({
        authorizationParams: { audience: AUTH0_AUDIENCE || undefined },
      });
      return api<T>(url, options, token);
    },
    [getAccessTokenSilently]
  );
}
